import React, { useState, useEffect } from "react";
import classnames from "classnames";
import {View} from "@instructure/ui-view";
import IasFormActions from "../FormActions/FormActions";
import { useStateValue } from "../../context-store/AppStateProvider";
import useAvailableLearners from "../../hooks/useAvailableLearners";
import { ACTIONS } from "../../context-store/ACTIONS";
import styles from "../FormCreateCourse/FormCreateCourse.module.scss";
import IasFormNumberInput from "../FormNumberInput/FormNumberInput";
import { Alert } from '@instructure/ui-alerts'

const IasFormAddMinorLearner = () => {
  const [, dispatch] = useStateValue();
  const [resetForm, setResetForm] = useState(false);
  const [{ launchCourseId, userId, token }] = useStateValue();

  const { response: availableLearnersResponse } = useAvailableLearners();
  const [ maximumLearners, setmaximumLearners] = useState(0);

  useEffect(() => {
    if (availableLearnersResponse) {
        setmaximumLearners(availableLearnersResponse.availableLearners);
    }
  }, [availableLearnersResponse]);

  const initialFormValues = {
    addedLearnerCount: 0,
  };

  const initialFormValidation = {
    addedLearnerCount: false,
  };

  const [formValues, setFormValues] = useState(initialFormValues);
  const [formValidation, setFormValidation] = useState(initialFormValidation);
  const [isFormValid, setIsFormValid] = useState(false);
  const [isFormDirty, setIsFormDirty] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [isBusy, setIsBusy] = useState(false);

  useEffect(() => {
    if (!Object.values(formValidation).every((value) => value === true)) {
      return setIsFormValid(false);
    }
    return setIsFormValid(true);
  }, [formValidation]);

  const handleSelectedOption = (name, option) => {
    if (!isFormDirty) {
      setIsFormDirty(true);
    }

    setFormValues({ ...formValues, [`${name}`]: option });
    setFormValidation({ ...formValidation, [`${name}`]: true });
  };

  const handleResetForm = () => {
    dispatch({
      type: ACTIONS.RESET_PROGRESS_ALERT,
    });
    setFormValidation(initialFormValidation);
    setFormValues(initialFormValues);
    setIsFormDirty(false);
    setResetForm(true);
    setTimeout(() => {
      setResetForm(false);
    }, 0);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const queryParams = [];
    queryParams.push("courseId="+launchCourseId);
    queryParams.push("userId="+userId);
    Object.keys(formValues).forEach(key => queryParams.push(`${key}=${formValues[key]}`));

    const url = `/api/addMinorLearner?${queryParams.join('&')}`;

    setIsBusy(true);
    fetch(url, {
      headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
      },
      method: "PUT",
      credentials: 'same-origin'
    }).then(() => setIsBusy(false)).catch();

    setmaximumLearners(Math.max(maximumLearners - Number(formValues.addedLearnerCount), 0));

    setShowSuccess(true);
  };

  return (
    <View as="section" padding="none medium medium">
      { showSuccess && <Alert variant="success" onDismiss={() => setShowSuccess(false)}>Your learners are being added to the course.  This operation may take several minutes.</Alert> }
      <form
        className={classnames(styles.FormCreateCourse)}
        onSubmit={handleFormSubmit}>
        <IasFormNumberInput
          id="addedLearnerCount"
          name="addedLearnerCount"
          label={"Number of Learners to Add"}
          reset={resetForm}
          placeholder={"Select the amount required"}
          isRequired={true}
          messages={[
            {
              type: "hint",
              text: `You can add a maximum of ${maximumLearners} students`,
            },
          ]}
          size="medium"
          onChange={handleSelectedOption}
          maxValue={maximumLearners}
          minValue={1}
        />

        <IasFormActions
          onReset={handleResetForm}
          disableReset={!isFormDirty || isBusy}
          disableSubmit={!isFormValid || isBusy}
        />
      </form>
    </View>
  );
};

export default IasFormAddMinorLearner;
